import api from '../services/api';

// Baixa o PDF de GET /veiculos/:id/contrato-compra. Erros vêm como JSON dentro do blob.
export async function baixarContratoCompra(id) {
  try {
    const r = await api.get('/veiculos/' + id + '/contrato-compra', { responseType: 'blob' });
    const url = URL.createObjectURL(r.data);
    const a = document.createElement('a');
    a.href = url; a.download = 'contrato_compra_' + id + '.pdf';
    document.body.appendChild(a); a.click(); a.remove();
    setTimeout(() => URL.revokeObjectURL(url), 10000);
  } catch (e) {
    let msg = 'Erro ao gerar contrato';
    try { msg = JSON.parse(await e.response.data.text()).error || msg; } catch (_) {}
    alert(msg);
  }
}

export const podeContratoCompra = v =>
  String(v?.tipo_entrada || '').toLowerCase() === 'compra' && !!v?.comprado_de_cliente_id;
